module.exports = __webpack_public_path__ + "static/media/背景.e604d1e7.png";